import { MoreVert } from '@mui/icons-material';
import {
  Box,
  Stack,
  Typography,
  IconButton
} from '@mui/material';
import { menuUtil } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { FolderMenu } from 'modules/components/layer19';
import React from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';
import { theme } from 'theme';



export type FolderCardProps = {
  id: string;
  fileName: string;
  fileCount: number;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FolderCardProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    if (path.endsWith('files')) {
      navigate(`../folders/${props.id}`);
    }
  };

  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();
  return (
    <Box
      onClick={() => handleNavigate(location.pathname)}
      width='calc((100% / 4) - (.6rem))'
      minWidth='16rem'
      display='flex'
      flexDirection='row'
      bgcolor={theme.palette.secondary.main}
      justifyContent='space-between'
      alignItems='center'
      padding='1.25rem'
      borderRadius='1rem'
      gap='1rem'
    >
      <Box>
        <CustomIcon.large.FC

          icon='FOLDERALT'
          stroke={theme.palette.primary.main}
        />
      </Box>
      <Stack
        overflow='hidden'
        flexGrow='1'
      >
        <Typography
          noWrap
          textOverflow='ellipsis'
          variant='bodyBold'
        >
          {props.fileName}
        </Typography>
        <Typography
          variant='body1'
        >
          {props.fileCount} {props.fileCount === 1 ? ' File' : ' Files'}
        </Typography>
      </Stack>
      <IconButton
        onClick={(e) => {
          handleClick(e);
          e.stopPropagation();
        }}
      >
        <MoreVert />
      </IconButton>
      {anchorEl && (
        <FolderMenu.FC
          open={open}
          anchorEl={anchorEl ?? null}
          handleClick={handleClick}
          handleClose={handleClose}
          id={props.id}
        />
      )}
    </Box>
  );
};
